import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Tooltip } from 'antd';
import { ScissorOutlined } from '@ant-design/icons';
import { openModal } from '../../actions/modal';
import ConnectedPatientSplitRowIcon from '../patientSplit/PatientSplitRowIcon';
import './autoSplit.scss';

const AutoSplitIcon = ({
  sendToken,
  fromPage,
  record,
  hasSplitSuggestion,
  isDismissed,
  openModal: dispatchOpenModal,
}) => {
  if (record.has_automatic_patient_split && record.file_token) {
    return <ConnectedPatientSplitRowIcon key={record.file_token} fileToken={record.file_token} fromPage={fromPage} />;
  }

  // Show icon based on backend flag, don't show if dismissed
  if (!hasSplitSuggestion || isDismissed) {
    return null;
  }

  const handleClick = (e) => {
    e.stopPropagation();
    e.preventDefault();
    dispatchOpenModal({
      type: 'AUTO_SPLIT_SUGGESTION',
      data: {
        sendToken,
        record,
      },
    });
  };

  return (
    <Tooltip title="AI suggested split available" placement="topRight">
      <span className="auto-split-row-icon" onClick={handleClick}>
        <ScissorOutlined />
        <span className="auto-split-row-icon-badge">AI</span>
      </span>
    </Tooltip>
  );
};

AutoSplitIcon.propTypes = {
  sendToken: PropTypes.string.isRequired,
  fromPage: PropTypes.string,
  record: PropTypes.object.isRequired,
  hasSplitSuggestion: PropTypes.bool,
  isDismissed: PropTypes.bool,
  openModal: PropTypes.func.isRequired,
};

AutoSplitIcon.defaultProps = {
  fromPage: 'received',
  hasSplitSuggestion: false,
  isDismissed: false,
};

const mapStateToProps = (state, ownProps) => {
  const { sendToken, record } = ownProps;

  return {
    hasSplitSuggestion: record?.has_split_suggestion || false,
    isDismissed: state.autoSplit?.dismissed?.[sendToken] || false,
  };
};

export default connect(mapStateToProps, { openModal })(AutoSplitIcon);
